<template>
	<div class="body">
        <!--左侧bar-->
        <div class="left-bar">
            <div class="logo_area">
                <img src="/admin/static/images/login_icon.png" class="logo" />
                <span>管理中心</span>
            </div>
            <ul class="left-menus">
                <li v-for="(item,idx) in menu" :key="idx" :class="{'on':active===item.url}">
                    <a href="javascript:;" @click="toUrl(item)">
                        <i class="fa" :class="item.icon"></i>
                        <span>{{ item.menu_name }}</span>
                    </a>
                </li>
            </ul>
        </div>
        <div class="main">
            <!--顶部bar-->
            <div class="top-bar">
                <div>
                    <span class="top-title">{{ title }}</span>
                </div>
                <div>
                    <el-dropdown @command="handleCommand">
                        <span class="el-dropdown-link">
                            <span class="top-name">{{ userinfo.uname }}</span><i class="el-icon-arrow-down el-icon--right"></i>
                         </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="exit">退出</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
            <!--内容区-->
            <div class="main-body" id="mainBody">
                <router-view></router-view>
            </div>
        </div>
        
	</div>
</template>

<script>
    import cookie from 'vue-cookie';
export default {
	name: 'HelloWorld',
	data () {
		return {
            active:''
		}
	},
	computed:{
        userinfo(){
		    return this.$store.state.system.userinfo;
        },
        menu(){
            return this.$store.state.system.menu;
        },
        title(){
            return this.$store.state.system.itemTitle;
        }
	},
    methods:{
	    //跳转
        toUrl(obj){
            this.$router.push({path:obj.url});
            this.active = obj.url;
        },

        handleCommand(command){
            if(command==='exit'){
                this.$store.commit('xMenu',[]);
                this.$store.commit('xUserInfo',null);
                this.$store.commit('xItemTitle','');
                cookie.delete('sc1',{domain:this.$getHost()});
                //this.$router.replace({path:'/login'});
                window.location.replace('/');
            }
        }
    },
    created(){
	   
    },
    mounted(){
        if(this.menu.length>0){
            this.toUrl(this.menu[0]);
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.body{position: absolute;left:0;top:0;right:0;bottom:0;overflow: hidden;}
	.left-bar{position: absolute;left:0;top:0;bottom:0;width:200px;background:#676B70;}
	.main{position: absolute;left:201px;top:0;right:0;bottom:0;overflow-y:hidden;}
    
    .logo_area{
        display:flex;
        height:70px;
        padding-left:30px;
        align-items: center;
        color:#fff;
        font-size:20px;
        text-shadow: 1px 3px 3px rgba(0,0,0,.5);
        background:#5F6367;
    }
    .logo{
        display:inline-block;
        width:25px;
        margin-right:10px;
        box-shadow: 1px 3px 3px rgba(0,0,0,.5);
    }
    .left-menus{
        position: absolute;
        left:0;top:70px;right:0;bottom:0;
        overflow:hidden;
        overflow-y:auto;
    }
    .left-menus li{
        height:50px;
        background:#434949;
        border-top:1px solid #5B6161;
    }
    .left-menus li i.fa{
        width:20px;
        
    }
    .left-menus li a{
        position: relative;
        display:block;
        height:100%;
        line-height:50px;
        color:#aaa;
        padding-left:35px;
        text-decoration: none;
        transition: all .2s;
        border-left:5px solid transparent;
    }
    .left-menus li a:hover{
        color:#fff;
        background:rgba(0,168,145,.1);
        border-left-color:rgba(255,222,0,.1);
    }
    .left-menus li.on a{
        background:rgba(0,168,145,1);
        border-left-color:rgba(255,222,0,1);
        color:#fff;
    }
    .left-menus li.on a:after{
        position: absolute;
        right:0;
        top:15px;
        content:'';
        border-right:10px solid #F2F2F2;
        border-top:10px solid transparent;
        border-bottom:10px solid transparent;
    }
    
    
    .top-bar{
        display:flex;
        justify-content: space-between;
        align-items: center;
        padding-right:20px;
        position:absolute;
        left:0;top:0;right:0;
        height:50px;
        background:#fff;
        box-shadow: 0 1px 2px 0 rgba(0,0,0,.05)
    }
    .top-name{
        color:#333;
        cursor: pointer;
    }
    
    .main-body{
        position: absolute;
        left:0;top:51px;right:0;bottom:0;
        overflow:hidden;
        overflow-y:auto;
    }
    .top-title{
        font-size:18px;line-height:50px;
        padding-left:15px;
    }
    
</style>



// WEBPACK FOOTER //
// src/components/Index.vue